import { items, MarkOfExcellence } from '@wg/wows-entities/const';
import moment from "moment";

export const isEmptyObject = (obj: Record<string, any>) => {
  if (!obj) {
    return false;
  }

  return Object.keys(obj).length === 0;
};

const isStat = (value: MarkOfExcellenceStat | MarkOfExcellenceShip): value is MarkOfExcellenceStat => {
  return 'name' in value;
};

const isShip = (value: MarkOfExcellenceStat | MarkOfExcellenceShip): value is MarkOfExcellenceShip => {
  return 'ship_id' in value;
};

export const getMarkOfExcellenceDate = (date: string | undefined) => {
  return date ? moment(date).format('DD.MM.YYYY') : '';
};

export const getAvailableMarkOfExcellence = (
  itemMark: MarkOfExcellenceStat | MarkOfExcellenceShip,
  label: items,
): StatisticsHeaderItem => {
  let data: StatisticsHeaderItem = {
    value: MarkOfExcellence.Mark_None,
    label,
  };

  if (isStat(itemMark)) {
    data = {
      value: itemMark?.name || MarkOfExcellence.Mark_None,
      label,
      ...(!isEmptyObject(itemMark) && {
        options: {
          achieved_at: getMarkOfExcellenceDate(itemMark?.achieved_at),
          percentile: itemMark.percentile,
        },
      }),
    };
  } else if (isShip(itemMark)) {
    data = {
      value: itemMark?.grade?.name || MarkOfExcellence.Mark_None,
      label,
      ...(!isEmptyObject(itemMark) && {
        options: {
          achieved_at: getMarkOfExcellenceDate(itemMark?.achieved_at),
          percentile: itemMark.percentile,
          battles_left: itemMark?.battles_left || 0,
        },
      }),
    };
  }

  return data;
};
